module.exports = __webpack_public_path__ + "static/media/Willpower.dc2c4565.svg";